<template>
  <b-card
    :title="device.device_name"
    :class="device.device_name.toLowerCase() !== 'debit' ? 'my-custom-class' : ''"
    :style="hasLimit ? { backgroundColor: device.device_value < limit.min || device.device_value > limit.max ? '#FC4C02' : 'green' } : ''"
  >
    <div class="ml-2">
      <h1>
        <font :color="device.device_name.toLowerCase() !== 'debit' ? 'white' : ''">
          {{ device.device_value }}
        </font>
        <small>
          <font :color="device.device_name.toLowerCase() !== 'debit' ? 'white' : ''">{{ device.device_default_unit }}</font>
        </small>
      </h1>
    </div>
  </b-card>
</template>
<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'DeviceCard',
  components: { BCard },
  props: {
    device: {
      type: Object,
      default: () => {},
    },
    limit: {
      type: Object,
      default: () => {},
    },
    hasLimit: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
